import React, { useEffect, useState } from "react";
import { api } from "../lib/api";

export default function Stats() {
  const [s, setS] = useState(null);
  useEffect(() => { api.get("/stats").then((r) => setS(r.data)); }, []);

  if (!s) return <div className="p-6 md:p-8">Yükleniyor…</div>;

  const rate = (approved, rejected) => {
    const total = approved + rejected;
    return total ? Math.round((approved / total) * 100) : 0;
  };

  return (
    <div className="p-6 md:p-8 max-w-[1400px]" data-testid="stats-page">
      <div className="label-overline">İstatistik</div>
      <h1 className="mt-2 font-display font-black text-3xl md:text-4xl tracking-tight">Vize Onay/Red Raporu</h1>

      <div className="mt-8 grid grid-cols-2 md:grid-cols-4 gap-4">
        <Card label="Toplam" v={s.total} />
        <Card label="Onaylanan" v={s.approved} tone="green" />
        <Card label="Red" v={s.rejected} tone="red" />
        <Card label="Onay Oranı (Karar Verilenler)" v={`%${rate(s.approved, s.rejected)}`} />
      </div>

      <div className="mt-10">
        <h2 className="font-display font-bold text-xl mb-4">Ülke Bazlı Detay</h2>
        <div className="grid-card overflow-x-auto">
          <table className="w-full text-sm min-w-[720px]">
            <thead className="bg-zinc-50 text-left">
              <tr className="border-b border-zinc-200">
                <Th>Ülke</Th><Th>Toplam</Th><Th>Onay</Th><Th>Red</Th><Th>Onay % (Karar)</Th><Th>Bar</Th>
              </tr>
            </thead>
            <tbody>
              {s.by_country.map((c) => {
                const r = rate(c.approved, c.rejected);
                return (
                  <tr key={c.country_id} className="border-b border-zinc-100">
                    <Td className="font-medium">{c.country_name}</Td>
                    <Td>{c.total}</Td>
                    <Td className="text-[#00913c]">{c.approved}</Td>
                    <Td className="text-[#b71c1c]">{c.rejected}</Td>
                    <Td>%{r}</Td>
                    <Td>
                      <div className="w-40 h-2 bg-zinc-100 rounded overflow-hidden flex">
                        <div className="bg-[#00913c] h-full" style={{ width: `${c.approved / Math.max(c.total,1) * 100}%` }} />
                        <div className="bg-[#b71c1c] h-full" style={{ width: `${c.rejected / Math.max(c.total,1) * 100}%` }} />
                      </div>
                    </Td>
                  </tr>
                );
              })}
              {s.by_country.length === 0 && <tr><td colSpan={6} className="p-8 text-center text-sm text-zinc-500">Veri yok</td></tr>}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}

const Th = ({ children }) => <th className="px-4 py-3 label-overline font-medium">{children}</th>;
const Td = ({ children, className = "" }) => <td className={`px-4 py-3 ${className}`}>{children}</td>;
const Card = ({ label, v, tone = "default" }) => {
  const c = { default: "text-zinc-950", green: "text-[#00913c]", red: "text-[#b71c1c]" }[tone];
  return (
    <div className="grid-card p-6">
      <div className="label-overline">{label}</div>
      <div className={`mt-3 font-display font-black text-4xl ${c}`}>{v}</div>
    </div>
  );
};
